import * as Quotes from '../slices/quotesSlice';
import { useAppSelector } from '../slices/index';

const QuoteSummary = () => {
	const quotes = useAppSelector(state => state.quotes);

	return (
		<div>
			{quotes.quote.quotebreakdown && !isNaN(parseFloat(quotes.quote.quotebreakdown.FeesTotal.toString())) &&
				<div style={{ maxWidth: 1280, margin: 'auto', padding: 16 }}>
					<div style={{ display: 'flex', margin: 4, borderBottom: '1px solid #F4941E' }}>
						<div className='row75' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24 }}>Our Fees:</div>
						<div className='row25' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24, textAlign: 'right' }}>£{(quotes.quote.quotebreakdown?.PLSFee && quotes.quote.quotebreakdown?.IntroducerFee) ? (parseFloat(quotes.quote.quotebreakdown?.PLSFee) + parseFloat(quotes.quote.quotebreakdown?.IntroducerFee)).toFixed(2) : parseFloat(quotes.quote.quotebreakdown.Fees).toFixed(2)}</div>
					</div>

					<div style={{ display: 'flex', margin: 4, borderBottom: '1px solid #F4941E' }}>
						<div className='row75' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24 }}>Extra Fees:</div>
						<div className='row25' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24, textAlign: 'right' }}>£{parseFloat(quotes.quote.quotebreakdown.ExtraFeesTotal).toFixed(2)}</div>
					</div>

					<div style={{ borderBottom: '1px solid #F4941E' }}>
						{(quotes.quote.quotebreakdown.ExtraFees || []).map((item: Quotes.feeState) => (
							<div key={item.Code} style={{ display: 'flex', margin: 4 }}>
								<div className='row75' style={{ fontFamily: 'OpenSans-Regular', fontSize: 18 }}>{item.Description}</div>
								<div className='row25' style={{ fontFamily: 'OpenSans-Regular', fontSize: 18, textAlign: 'right' }}>£{parseFloat(item.Value).toFixed(2)}</div>
							</div>
						))}
					</div>

					<div style={{ display: 'flex', margin: 4, borderBottom: '1px solid #F4941E' }}>
						<div className='row75' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24 }}>V.A.T.:</div>
						<div className='row25' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24, textAlign: 'right' }}>£{parseFloat(quotes.quote.quotebreakdown.Vat).toFixed(2)}</div>
					</div>

					<div style={{ display: 'flex', margin: 4, borderBottom: '1px solid #F4941E' }}>
						<div className='row75' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24 }}>Fees Total:</div>
						<div className='row25' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24, textAlign: 'right' }}>£{parseFloat(quotes.quote.quotebreakdown.FeesTotal).toFixed(2)}</div>
					</div>

					<div style={{ display: 'flex', margin: 4, borderBottom: '1px solid #F4941E' }}>
						<div className='row75' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24 }}>Disbursements:</div>
						<div className='row25' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24, textAlign: 'right' }}>£{parseFloat(quotes.quote.quotebreakdown.DisbursementsTotal).toFixed(2)}</div>
					</div>

					<div style={{ borderBottom: '1px solid #F4941E' }}>
						{(quotes.quote.quotebreakdown.Disbursements || []).map((item: Quotes.feeState) => (
							<div key={item.Code} style={{ display: 'flex', margin: 4 }}>
								<div className='row75' style={{ fontFamily: 'OpenSans-Regular', fontSize: 18 }}>{item.Description}</div>
								<div className='row25' style={{ fontFamily: 'OpenSans-Regular', fontSize: 18, textAlign: 'right' }}>£{parseFloat(item.Value).toFixed(2)}</div>
							</div>
						))}
					</div>

					<div style={{ display: 'flex', margin: 4, borderBottom: '1px solid #F4941E' }}>
						<div className='row75' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24 }}>Total:</div>
						<div className='row25' style={{ fontFamily: 'OpenSans-Bold', fontSize: 24, textAlign: 'right' }}>£{parseFloat(quotes.quote.quotebreakdown.Total).toFixed(2)}</div>
					</div>

					<p>The legal fee is our fee for completing the required work on your transaction. This is an estimate based on the information you have provided us. Should we find that there are additional circumstances which carry a fee, we will let you know before we incur that cost.</p>
					<p>Disbursements are costs which are incurred during the process of your transaction. These costs are mainly from the likes of Land Registry and the HMRC (if indeed you are liable for stamp duty). PLS will make you aware of these and costs like it as we progress and can explain why they are being incurred, but ultimately PLS have no control of the costs for 3rd parties.</p>
				</div>
			}
		</div>
	);
}

export default QuoteSummary;